import { Apple, Play } from "lucide-react";

/**
 * Re-usable "Coming soon to App Store / Google Play" badges.
 * - variant="dark": black pill buttons (default, for light sections)
 * - variant="light": white outline (for dark sections)
 * - size="sm" | "md"
 */
export default function AppStoreBadges({
  variant = "dark",
  size = "md",
  className = "",
}) {
  const isLight = variant === "light";
  const sm = size === "sm";
  const base = `inline-flex items-center gap-3 rounded-2xl px-${sm ? "4" : "5"} py-${sm ? "2.5" : "3"} cursor-not-allowed transition`;
  const style = isLight
    ? "bg-white/10 border border-white/25 text-white hover:bg-white/15"
    : "bg-black text-white opacity-90";

  return (
    <div className={`flex flex-wrap gap-3 ${className}`}>
      <button type="button" disabled aria-label="App Store — coming soon" className={`${base} ${style}`}>
        <Apple size={sm ? 22 : 26} className="-mt-0.5" fill="currentColor" />
        <div className="text-left leading-tight">
          <div className={`${sm ? "text-[9px]" : "text-[10px]"} uppercase tracking-wider opacity-80`}>
            Coming soon to
          </div>
          <div className={`${sm ? "text-[14px]" : "text-[16px]"} font-semibold`}>App Store</div>
        </div>
      </button>
      <button type="button" disabled aria-label="Google Play — coming soon" className={`${base} ${style}`}>
        <Play size={sm ? 20 : 24} fill="currentColor" />
        <div className="text-left leading-tight">
          <div className={`${sm ? "text-[9px]" : "text-[10px]"} uppercase tracking-wider opacity-80`}>
            Coming soon to
          </div>
          <div className={`${sm ? "text-[14px]" : "text-[16px]"} font-semibold`}>Google Play</div>
        </div>
      </button>
    </div>
  );
}
